import { FC } from 'react';
import { H2 } from '../../../../common/Headings/Headings.styles';
import Button from '../../../../components/Button/Button';
import { Variant } from '../../../../components/Button/Button.types';
import Table from '../../../../components/Table/Table';
import { showToast } from '../../../../components/Toast/Toast';
import { genericErrorShowToastOptions } from '../../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import { Buttons, StyledReviewChanges, TableRowWrapper } from './ReviewChanges.styles';
import { ReviewChangesProps } from './ReviewChanges.types';
import { ChangeSpecsStep } from "../ChangeSpecs.types";

const ReviewChanges: FC<ReviewChangesProps> = ({
                                                   selectedSpecs,
                                                   selectedMenus,
                                                   mutate,
                                                   setStep
                                               }) => {
    const editSpec = () => setStep(ChangeSpecsStep.SelectSpec);
    const editMenu = () => setStep(ChangeSpecsStep.SelectMenus);

    const changeSpecOperations = selectedSpecs.map((combinedSpec) => {
        return {
            currentSpec: combinedSpec.currentSpecNo,
            desiredSpec: combinedSpec.desiredSpecNo
        }
    })

    const menus = selectedMenus.map((menu) => {
        return menu.id;
    });

    const handleSaveClick = () => {
        mutate(
            {
                menus: menus,
                operations: changeSpecOperations
            },
            {
                onSuccess: () => {
                    setStep(ChangeSpecsStep.Confirmation);
                    showToast({ label: 'Menu(s) updated successfully.', id: 'changeMenuSpecsSuccess' });
                },
                onError: () => {
                    showToast({
                        ...genericErrorShowToastOptions,
                        id: 'changeMenuSpecsError',
                        label: 'Error updating menu specs.'
                    });
                }
            }
        );
    };

    return (
        <StyledReviewChanges>
            <H2>Review your changes</H2>
            <TableRowWrapper>
                <Table
                    rowData={selectedSpecs}
                    showHeader={true}
                    showFooter={false}
                    headerTitle="Selected Specs"
                    headerButtons={[{ label: 'Edit', variant: Variant.Text, onClick: editSpec }]}
                    floatingFiltersHeight={0}
                    columnDefs={[
                        { minWidth: 110, flex: 1, field: 'currentSpecNo', headerName: 'Current Spec' },
                        { minWidth: 110, flex: 1, field: 'currentDescription', headerName: 'Current Description' },
                        { minWidth: 110, flex: 1, field: 'desiredSpecNo', headerName: 'Desired Spec' },
                        { minWidth: 110, flex: 1, field: 'desiredDescription', headerName: 'Desired Description' }
                    ]}
                />
            </TableRowWrapper>
            <TableRowWrapper>
                <Table
                    rowData={selectedMenus}
                    showHeader={true}
                    showFooter={false}
                    headerTitle="Affected Menus"
                    headerButtons={[{ label: 'Edit', variant: Variant.Text, onClick: editMenu }]}
                    floatingFiltersHeight={0}
                    columnDefs={[
                        { minWidth: 220, flex: 1, field: 'parents.store', headerName: 'MxRef' },
                        { minWidth: 320, flex: 2, field: 'id', headerName: 'Menu', resizable: false }
                    ]}
                />
            </TableRowWrapper>
            <Buttons>
                <Button label="Back" variant={Variant.Secondary} onClick={editMenu}/>
                <Button label="Save" testId="SaveChangesButton" onClick={handleSaveClick}/>
            </Buttons>
        </StyledReviewChanges>
    );
};

export default ReviewChanges;